export const removeAllParamsURL = () => {
  window.history.replaceState(null, null, window.location.pathname);
};
